import { useEffect, useRef, useContext, useState } from "react";
import PropTyps from "prop-types";
import { FontSizeContext } from "../../context/fontSizeContext";

const Team = ({ data }) => {
    const { fontSize } = useContext(FontSizeContext);
    const textRefs = useRef([]);
    const [defaultSizes, setDefaultSizes] = useState([]);

    const adjustFontSize = (change) => {
        textRefs.current.forEach((element, index) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                const currentSize = parseFloat(computedStyle.fontSize);
                const newSize = currentSize + change;
                element.style.fontSize = `${newSize}px`;
            }
        });
    };

    const resetFontSize = () => {
        textRefs.current.forEach((element, index) => {
            if (element && defaultSizes[index] !== null) {
                element.style.fontSize = `${defaultSizes[index]}px`;
            }
        });
    };

    useEffect(() => {
        if (fontSize == 0) {
            resetFontSize();
        } else {
            adjustFontSize(fontSize);
        }
    }, [fontSize]);

    useEffect(() => {
        const sizes = textRefs.current.map((element) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                return parseFloat(computedStyle.fontSize);
            }
            return null;
        });
        setDefaultSizes(sizes);
    }, []);

    return (
        <div className="new-team-members-list">
            <img src={process.env.PUBLIC_URL + data.thumb} alt="images" />
            <h3 ref={(el) => (textRefs.current[0] = el)} className="title">
                {data.name}
            </h3>
            <span ref={(el) => (textRefs.current[1] = el)}>
                {data.designation}
            </span>
        </div>
    );
};

Team.propTypes = {
    data: PropTyps.object,
};

export default Team;
